import {SignalChannelState} from '../../../../api/proto';
import i18n from '../../../../i18n';


export default function getSignalStateTitle(state?: SignalChannelState.State | null): string {
  switch (state) {
    case SignalChannelState.State.CREATE_CHANNEL:
      return i18n.t('settings_channel_manage_status_authorization');
    case SignalChannelState.State.EVENT_LISTENING:
      return i18n.t('settings_channel_manage_status_launch');

    default:
      return '-';
  }
}